import Swal from 'sweetalert2'

const baseOptions = {
  confirmButtonText: 'OK'
}

export function showAlert (options = {}) {
  return Swal.fire({
    ...baseOptions,
    icon: options.icon || 'info',
    title: options.title || 'Notice',
    text: options.text || '',
    ...options
  })
}

export function showInfoAlert (text, title = 'Notice') {
  return showAlert({ icon: 'info', title, text })
}

export function showSuccessAlert (text, title = 'Success') {
  return showAlert({ icon: 'success', title, text })
}

export function showWarningAlert (text, title = 'Attention') {
  return showAlert({ icon: 'warning', title, text })
}

export function showErrorAlert (text, title = 'Something Went Wrong') {
  return showAlert({ icon: 'error', title, text })
}

export async function showConfirmAlert (options = {}) {
  const result = await Swal.fire({
    ...baseOptions,
    icon: options.icon || 'warning',
    title: options.title || 'Are you sure?',
    text: options.text || '',
    confirmButtonText: options.confirmButtonText || 'Confirm',
    cancelButtonText: options.cancelButtonText || 'Cancel',
    showCancelButton: true,
    reverseButtons: true,
    focusCancel: true,
    ...options
  })

  return !!result.isConfirmed
}
